<template>
  <el-main>
    <el-row>
      <h2>成绩查询</h2>
    </el-row>      

            
     <el-row 
        v-show="isshow">     
        <span>考号: {{ st_kaohao }}</span>
        <span>姓名: {{ st_name }}</span>     
        <span>学校: {{ st_school }}</span>
        <span>班级: {{ st_class }}</span>        
     </el-row> 
        
  <b-row>
        <b-col lg="6" class="my-1">          
                  
       
        
                    <b-table       
                    
                    hover 
                    :items="dankeArray" 
                    :fields="fields"
                    :small="true"
                    :bordered="true"
                    :head-variant="headVariant"                 
                  
                    >
      
                      <template v-slot:cell(baobiao)="row">
                          <b-button size="sm" @click="handleXiaoti(row.item, row.index, $event.target)" class="mr-2">
                            详情
                          </b-button>
                          
                        </template>

                        <template v-slot:cell(sjimage)="row">
                          
                          <b-button size="sm"   @click="info(row.item, 11, $event.target)" class="mr-2">
                            正面
                          </b-button>

                          <b-button size="sm"   @click="info(row.item, 22, $event.target)" class="mr-2">
                            背面
                          </b-button>
                          
                        </template>

                  </b-table>
         </b-col>

         <b-col lg="6" class="my-1"> 
           
                <b-row >
                  <b-col lg="4" class="my-1"> 
                          <ve-histogram :data="chartData" :settings="chartSettings" ></ve-histogram>                
                            
                  </b-col>
                  
                  <b-col lg="4" class="my-1">  

                    <b-table
            
                        hover 
                          :fields="fieldXt"
                            :small="true"
                            :bordered="true"
                            :head-variant="headVariant"
                          :items="itemsXt"
                        >
                        </b-table>
                                        
                  </b-col>
              </b-row>   

         </b-col>

    </b-row>
 

    

 
           


  </el-main>
  

</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    return {
      		img_src:'',
          fit:'contain',
          xmList: [],
          currentRow: null,
          status:false,
          title:'hello world',
          schoolList:[],
          selXmName:'',
          selSchool:'',
          selClass:'',
          editableTabs: [
            {
                title: 'Tab 1',
                name: '1',
                content: 'Tab 1 content'
            }, 
            {
                  title: 'Tab 2',
                  name: '2',
                  content: 'Tab 2 content'
            }
            ],
          st_kaohao: '',
          st_name: '',
          st_school:'',
          st_class:'',
          sel_row_index:0,
          dankeArray: [],
          fields: [
              {
                key: 'kemu',
                label: '科目',
              },
              {
                key: 'score',
                label: '分数',
              },
              {
                key: 'c_paiming',
                label: '班名次',
              },
              {
                key: 's_paiming',
                label: '校名次',
              },
              {
                key: 'baobiao',
                label: '报表',
              },
              {
                key: 'sjimage',
                label: '试卷图像',
              },
              
            ],

          sel_xm:'',
          isshow:false,
          headVariant:'light',
           chartData: {
              columns: ['sb','个人得分', '班均分', '校均分'],
              rows: []
               
              },
           chartSettings : {
        
                  xAxisName: ['均分对比'],
                  axisSite: {
                    top: ['均分对比']
                  },
                  itemStyle : { normal: {label : {show: true}}}
                },

            itemsXt:[],
            fieldXt: [
              {
                key: 'tihao',
                label: '题号',
              },
              {
                key: 'maxscore',
                label: '满分',
              },
              {
                key: 'score',
                label: '得分',
              },
               
            ],


         };
  },
  	 activated() {

       if (this.$route.params.xm!=null)
       {
          this.sel_xm=this.$route.params.xm;

          this.st_kaohao=this.$route.params.kaohao;
          this.st_name=this.$route.params.name;
        
          this.handleoneStudentScore();
       }

  },
  
  methods: {
         info(item, index, button) {
          console.log(item.kemu);
          console.log(index);
         // let xm=this.sel_xm;
          //let kh=item.kh;
          //let name=item.nm;
          // index 11时 正面  22时 背面


         let xm=this.sel_xm;
         let sb=item.kemu;
         let kaohao=this.st_kaohao;
       

         let page="front";
         if (index==22)
         {
             page="back";
         }

          //跳转图像页
          this.$router.push({

               name:'sjimg',
               params: { xm:xm,sb:sb,kaohao:kaohao,page:page }

        })

          

       
        
      },

       handleXiaoti(item, index, button) {
          console.log(item.kemu);
          console.log(index);
         // let xm=this.sel_xm;
          //let kh=item.kh;
          //let name=item.nm;
          // index 11时 正面  22时 背面


         let xm=this.sel_xm;
         let sb=item.kemu;
         let kaohao=this.st_kaohao;
       

         axios.post('/cjman?op=oneStudentXiaoti',qs.stringify({"xm":this.sel_xm,"kaohao":this.st_kaohao,"sb":sb,"school":this.st_school,"class":this.st_class})).then((res)=>{
              console.log(res);


              //this.chartData=res.data;
             // this.chartData.columns=res.data.columns;
              this.chartData.rows=res.data.junfen;
              
              console.log(this.chartData);
              console.log(res.data.columns);
              this.itemsXt=res.data.columns;
              
              this.isshow=true;
         

              
          }).catch((res)=>{
              console.log(response)
          })

          

       
        
      },


          tableRowClassName({ rowIndex }) {
          if (rowIndex % 2 === 0) {
            return "warning-row";
          } else if (rowIndex % 2 === 1) {
            return "success-row";
          }
          return "";
        },
     
      getSchoolList () {
          let postdata = {"xm":this.selXmName};
          axios.post('/cjman?op=exameSchool',qs.stringify({"xm":this.selXmName})).then((res)=>{
                  console.log(res)
                  this.schoolList=res.data;
                  
              }).catch((res)=>{
                  console.log(response)
              })
        },

     
     handleXm(index, row) {
        this.selXmName=this.xmList[index]["xmname"];
        console.log(index, row);
        console.log(this.xmList[index]["xmname"]);
        this.title="全体报表---------"+this.xmList[index]["xmname"];
        this.status=true;
        this.sel_row_index=index;
        axios.post('/cjman?op=exameKemu',qs.stringify({"xm":this.selXmName})).then((res)=>{
              console.log(res)
              this.editableTabs=res.data;
              
          }).catch((res)=>{
              console.log(response)
          })


       
      },

     handSjimg(index, row) {
       
         console.log(index);
         console.log(row);
         let sb=this.dankeArray[index]['kemu'];
         console.log(this.sel_xm);
         console.log(sb);
         console.log(this.st_kaohao);
         console.log(this.st_name);
         let page="front";

          //跳转图像页
          this.$router.push({

               name:'sjimg',

               params: { xm:this.sel_xm,sb:sb,kaohao:this.st_kaohao,page:page }

        })


  
      },
    
     handleClick () {
     axios.get('/cjman?op=exameList').then((res)=>{
                console.log(res)
                this.xmList=res.data;
                this.status=true;
            }).catch((res)=>{
                console.log(response)
            })
        },


       handleoneStudentScore () {              
         

              axios.post('/cjman?op=oneStudentScore',qs.stringify({"xm":this.sel_xm,"st_kaohao":this.st_kaohao,"st_name":this.st_name})).then((res)=>{
                    console.log(res);
                    
                    console.log(res.data.all_score);
                    this.dankeArray=res.data.dankeArray;
                    this.st_school=res.data.school;
                    this.st_class=res.data.class;
                    

                    
                }).catch((res)=>{
                    console.log(response)
                })


        },



       handleClickImg () {
             axios.get('/cjman?op=oneTizumg', {
                responseType: 'blob' //指定返回数据的格式为blob
            }).then((response)=>{
                console.log(response)
                 var urlCreator = window.URL || window.webkitURL;
								var imageUrl = urlCreator.createObjectURL( response.data );
								this.img_src = imageUrl; 
            }).catch((response)=>{
                console.log(response)
               
            })
       },

  },
}
</script>

<style lang="scss">
    .warning-row {
      background: #142e51;
    }
    .success-row {
      background: #011e47;
    }

  

</style>